import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AchievementsManagementPage from "@/pages/admin/AchievementsManagementPage";

export const Route = createFileRoute("/_admin/admin/achievements")({
  head: () => pageHead("Admin · Achievements", "AKIVA admin · achievements portal.", "/admin/achievements", true),
  component: AchievementsManagementPage,
});
